export default __webpack_public_path__ + "static/card1-3452cd108c02e871e14d999ed55c7aa3.webp";